import { z } from 'zod';
import { cpf, cnpj } from 'cpf-cnpj-validator';
import { validateBrazilianPhone } from '@/utils';
import { t } from '@/i18n';

// document/phone_number são opcionais (a DDL só exige NOT NULL, satisfeito com '')
// — validamos o formato apenas quando preenchidos, igual ao backend.
export const modalFormSchema = z
  .object({
    name: z.string().min(1, t('pages.access_control.components.user.schema.required') || ''),
    document: z
      .string()
      .refine(value => {
        return !value || cpf.isValid(value) || cnpj.isValid(value);
      }, t('pages.access_control.components.user.schema.invalid_document') || ''),
    phone_number: z
      .string()
      .refine(value => {
        return !value || validateBrazilianPhone(value);
      }, t('pages.access_control.components.user.schema.invalid_phone') || ''),

    email: z.string().email(t('pages.access_control.components.user.schema.invalid_email') || ''),
    email_confirmation: z.string().email(t('pages.access_control.components.user.schema.invalid_email') || ''),
  })
  .refine(data => data.email === data.email_confirmation, {
    message: t('pages.access_control.components.user.schema.email_mismatch') || '',
    path: ['email_confirmation'],
  });

export type ModalFormData = z.infer<typeof modalFormSchema>;
